import FeedbackCreate from "components/feedback";
import useMission from "pages/missionTen/hooks";
import { useReducer } from "react";
import { userInitialState } from "reducers/userInitState";
import { userReducer } from "reducers/userReducer";
import clearLocalStorage from "utils/clearlocalStorage";

function Feedback()
{
	const [ userState ] = useReducer(userReducer, userInitialState);
	const missionContext = useMission();

	function clearStorage()
	{
		clearLocalStorage("mission-ten");
	}

	function nextStep()
	{
		missionContext.setStep(13);
	}

	return (
		<FeedbackCreate nextStep={nextStep} missionNumber={10} name={userState.user?.name} clearStorage={clearStorage} />
	);
}

export default Feedback;
